import "./viewEvent.css";
import React from "react";
import moment from "moment";
import { IoClose } from "react-icons/io5";
import {
	EditIcon,
	UsersIcon,
	TimeIcon,
	RepeatIcon,
	// video,
	MenuIcon,
} from "../../../assets";
import { SlEvent } from "react-icons/sl";
import helperService from "../../../services/helper.service";

function ViewEvent({ event, title, onClose, handleEditEvent }) {
	// Split Participant's Email:
	const splitEmail = (email) => {
		const atIndex = email.indexOf("@");
		const username = email.substring(0, atIndex);

		if (username.includes(".")) {
			return username.split(".")[0];
		} else {
			return username;
		}
	};

	return (
		<>
			<div className="view_event_container">
				<div className="view_modal_event_header">
					<h1>{title}</h1>
					<IoClose className="view_modal_event_close_icon" onClick={onClose} />
				</div>

				<div className="view_modal_event_body">
					<div className="view_modal_title">
						<img src={EditIcon} alt="Edit Icon" />
						<h1>{event?.title}</h1>
					</div>

					<div className="view_modal_users">
						<img src={UsersIcon} alt="Users Icon" />
						<span>
							{event?.participants?.map((user, index) => {
								const userName = splitEmail(user);

								return <p key={index}>{`${userName} (${user})`};</p>;
							})}
						</span>
					</div>

					<div className="view_modal_events">
						<SlEvent className="SlEvent view" />
						<div
							className={`view_modal_event_inner event_mode_pill ${event?.eventMode}`}
						>
							<p>{helperService.capitalize(event?.eventMode)}</p>
						</div>
					</div>

					<div className="view_modal_time">
						<img src={TimeIcon} alt="Time Icon" />
						<div className="view_modal_time_inner">
							{event?.allDay ? (
								<div className="create_modal_time_inner_start_time">
									<p>{event?.allDay ? "All Day" : "Single"}</p>
								</div>
							) : null}

							<div className="view_modal_time_inner_start_time">
								<p>Start time</p>
								<p>
									{moment.utc(event?.startTime).format("DD MMM YYYY, hh.mm A")}
								</p>
							</div>
							<div className="view_modal_time_inner_end_time">
								<p>End time</p>
								<p>
									{moment.utc(event?.endTime).format("DD MMM YYYY, hh.mm A")}
								</p>
							</div>
						</div>
					</div>

					<div className="view_modal_repeat">
						<img src={RepeatIcon} alt="Repeat Icon" />
						<p>{event?.recurring ? "Recurring" : "None"}</p>
					</div>

					{/* <div className="view_modal_menu">
						<img src={MenuIcon} alt="Menu Icon" />
						<div className="view_modal_menu_inner">
							<span>
								<h3>Teams Meeting Link</h3>
								<img src={video} alt="Video Icon" />
							</span>
							<a href={event?.meetingLink} target="_blank" rel="noreferrer">
								Join link
							</a>
							<p>{event?.otherDetails}</p>
						</div>
					</div> */}

					<div className="view_modal_menu">
						<img src={MenuIcon} alt="Menu Icon" />
						<div className="view_modal_menu_inner">
							<span>
								<h3>Other Details</h3>
							</span>
							<p>{event?.otherDetails}</p>
						</div>
					</div>

					<div className="view_modal_button">
						<button
							className="view_modal_edit_button"
							onClick={() => handleEditEvent(event)}
						>
							Edit Event
						</button>
					</div>
				</div>
			</div>
		</>
	);
}

export default ViewEvent;
